import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import Chapters from "../../components/Chapter/ChapterList";


const ChapterListPage = () => {
  return (
    <>

        {/* Breadcrumb */}
        
        <div className="d-flex justify-content-between"><h5>Chapters  </h5><Breadcrumb title="Chapter" /></div>
        {/* UsersListLayer */}
        <Chapters />


    </>
  );
};

export default ChapterListPage; 
